<template>
  <WsMain>
    <WsBreadCrumbs :items="breadcrumbs.items" class="mb-3"></WsBreadCrumbs>
    <template>
      <WsCRUD
        v-for="(field, fieldKey) in _fields"
        :ref="`WsCRUD_${fieldKey}`"
        :key="fieldKey"
        noChangePage
        :hasMultiDeleteBtn="field.hasMultiDeleteBtn"
        :isMultiSelect="_isStageFinished ? false : field.isMultiSelect"
        :modelName="field.modelName"
        :label="field.label"
        :fields="field.fields"
        :showExpand="field.showExpand"
        :inRowBtnDelete="field.inRowBtnDelete"
        :inRowBtnUpdate="field.inRowBtnUpdate"
        :inRowBtnRead="field.inRowBtnRead"
        :isCreatable="field.isCreatable"
        :isFilterShow="field.isFilterShow"
        :filterSelects="field.filterSelects"
        :showFields="field.showFields"
        :hasSearchBtn="field.hasSearchBtn"
        :getUrl="field.getUrl"
        :getParams="field.getParams"
        :id="field.id ? `${field.id}` : `${field.versionId}`"
        :versionId="field.versionId"
        :isPaginationShow="field.isPaginationShow"
        :filterProps="field.filterProps"
        :displayHideFields="field.displayHideFields"
        :updateHideFields="field.updateHideFields"
        :customHideFields="field.customHideFields"
        :titleKey="field.readDialogTitleKey"
        :orderBy="field.orderBy"
        :orderWay="field.orderWay"
        @filter-select="$_onFilterSelect($event, fieldKey)"
        @set-modelDatas="$_onSetModelDatas($event, fieldKey)"
        @tab-switched="$_onTabSwitch($event, fieldKey)"
      >
        <template v-slot:customBtns="{ item, modelDatas }">
          <WsIconBtn
            v-for="(btn, btnIndex) in field.inRowCustomBtns"
            :ref="`iconBtn_${fieldKey}_${btn.value}_${item.id}`"
            :key="btnIndex"
            :tooltip="btn.tooltip"
            tooltipPosition="top"
            class="ml-1 mr-1"
            :disabled="item[`${btn.disabledKey}`]"
            :isLoading="item.btnLoading"
            @click="$_onInRowBtnClick(fieldKey, item, btn, modelDatas)"
            >{{ btn.icon }}</WsIconBtn
          >
        </template>
        <template
          v-slot:customDialog="{
            customFields,
            updateFields,
            displayFields,
            errorMessages,
            titleKey,
          }"
        >
          <WsUpdateDialog
            :ref="`checkFailDialog_${fieldKey}`"
            :label="field.label"
            :fields="customFields"
            :modelName="field.modelName"
            :errorMessages="errorMessages"
            :isLoading="isLoading.checkFailDialog"
            @update-submit="$_onSaveRemark(fieldKey, $event)"
          />
          <WsUpdateDialog
            isCloseScrollTop
            :ref="`updateDialog_${fieldKey}`"
            :label="field.label"
            :fields="updateFields"
            :modelName="field.modelName"
            :errorMessages="errorMessages"
            :customBtns="field.updateDialogSetting.customBtns"
            :isLoading="isLoading.updateDialog"
            @custom-emit="$_onDialogCustomAction($event, fieldKey, 'update')"
            @update-submit="$_onUpdateDialogSubmit($event, fieldKey)"
          />
          <WsReadDialog
            isCloseScrollTop
            :ref="`readDialog_${fieldKey}`"
            :fields="displayFields"
            :titleKey="titleKey"
            :deletable="false"
            :editable="false"
            :customBtns="field.readDialogSetting.customBtns"
            :isLoading="isLoading.readDialog"
            @custom-emit="$_onDialogCustomAction($event, fieldKey, 'read')"
          />
        </template>
        <template v-slot:multiSelectCustomBtns="{ items, modelDatas }">
          <WsBtn @click="$_onBatchPass(fieldKey, modelDatas, items, field.inRowCustomBtns)">
            <v-icon left>mdi-check</v-icon> 批次通過
          </WsBtn>
        </template>
      </WsCRUD>
    </template>
    <WsMainBottomNav v-if="!_isStageFinished">
      <div
        v-for="(btn, btnIndex) in statusBtnList"
        :key="btnIndex"
        class="d-flex align-center mr-2"
      >
        <v-chip small :color="btn.color" class="mr-1" />
        <div class="text-center" :style="{ 'line-height': '40px' }">{{ `: ${btn.text}` }}</div>
      </div>
      <v-icon v-if="!_isCheckedAll" size="20" color="alert" class="mr-1">mdi-alert-circle</v-icon>
      <div v-if="!_isCheckedAll" class="text-center alert--text" :style="{ 'line-height': '40px' }">
        尚有{{ _remainingItems }}法規或法條沒有進行鑑別
      </div>
      <WsBtn
        :disabled="!_isCheckedAll"
        :loading="isLoading.submit || isLoading.batchPass"
        @click="$_onOpenPopup('WsAlertDialog')"
        >{{ _customBtns.title }}</WsBtn
      >
    </WsMainBottomNav>
    <WsAlertDialog
      ref="WsAlertDialog"
      color="primary"
      btnText="確認完成"
      title="確認完成覆核法規內容格式更新作業嗎？"
      :description="submit.description"
      @submit="$_onSubmit(_customBtns.submitUrl)"
    />
    <WsAlertDialog ref="resultDialog" :title="resultDialog.title">
      <template v-slot:bottom-btn>
        <WsBtn color="primary" @click="$_onConfirmResultDialog">確認</WsBtn>
      </template>
    </WsAlertDialog>
    <WsAlertDialog
      ref="deleteDialog"
      title="僅用來刪除空白標題及內容的法條，確定要刪除嗎？"
      description="刪除後資料將無法回復"
      @submit="$_onDeleteSubmit($event)"
    />
  </WsMain>
</template>

<script>
import S_idtf from '@/services/api/v1/idtf';
import S_article from '@/services/api/v1/article';
import S_idtfItem from '@/services/api/v1/idtfItem';
import S_articleVersion from '@/services/api/v1/articleVersion';
import H_idtf from '@/helpers/idtf';
import Spare_idtf from '@/spare/idtf';

export default {
  name: 'Review',
  data() {
    return {
      modelName: 'act_idtf_assignment_items',
      subModelName: 'act_cnt_review_result',
      subModelSubmitUrl: `act_idtf_assignment/${this.$route.params.id}/act_idtf_assignment_item/act_cnt/review`,
      modelData: [],
      updateData: {
        act_cnt_review_result: [],
      },
      isLoading: {
        submit: false,
        updateDialog: false,
        readDialog: false,
        checkFailDialog: false,
        batchPass: false,
      },
      breadcrumbs: {
        fields: [
          {
            text: '我的覆核法規內容格式作業',
            url: '/act_cnt_review',
            disabled: false,
          },
          {
            getText: function (modelData) {
              return modelData[1].act_version.name;
            },
            getUrl: function (modelData) {
              const id = modelData[1].id;
              return `/act_cnt_review/${id}`;
            },
            disabled: false,
          },
          {
            text: '覆核法規格式內容',
            disabled: true,
          },
        ],
        items: [],
      },
      fields: {
        article: {
          filterProps: {},
        },
      },
      idtfItemsNumber: null,
      submit: {
        description: '',
      },
      resultDialog: {
        isReviewSuccess: false,
        title: '',
      },
      statusBtnList: Spare_idtf.statusBtnList,
    };
  },
  async mounted() {
    await this.$_fetchData();
    this.breadcrumbs.items = this.$_getBreadcrumbsItems();
  },
  methods: {
    async $_fetchData() {
      try {
        const idtfContent = await S_idtf.show(this._idtfId);
        const idtfItems = await S_idtf.indexAllIdtfItems(this._idtfId);
        this.idtfItemsNumber = idtfItems.length;
        this.modelData = [idtfItems, idtfContent];
        this.$_initUpdateData(idtfItems);
      } catch (error) {
        alert(error);
      }
    },
    $_onFilterSelect($event, fieldKey) {
      this.$set(this.fields[fieldKey], 'filterProps', $event);
    },
    async $_onUpdateDialogSubmit($event, fieldKey) {
      const updateDialog = this.$_getUpdateDialog(fieldKey);
      try {
        updateDialog.startLoading();
        const formattedUpdateData = this._fields[fieldKey].setUpdateData
          ? this._fields[fieldKey].setUpdateData($event)
          : $event;
        const indexInUpdateData = H_idtf.getUpdateDataIndex(
          this.updateData[fieldKey],
          'id',
          $event.id,
        );
        H_idtf.updateUpdateData(this.updateData, formattedUpdateData, fieldKey, indexInUpdateData);
        await this.$_updateCRUDData($event, fieldKey);
        const { getSubmitUrl, setSubmitData } = this._fields[fieldKey];
        if (getSubmitUrl) {
          const submitData = setSubmitData
            ? setSubmitData(formattedUpdateData)
            : formattedUpdateData;
          await this.$axios.patch(
            getSubmitUrl({
              id: $event.id,
              modelData: this.modelData,
              updateData: formattedUpdateData,
            }),
            submitData,
          );
        }
        updateDialog.stopLoading();
        if (updateDialog.dialog) updateDialog.close();
      } catch (error) {
        alert(error);
        updateDialog.stopLoading();
      }
    },
    async $_updateCRUDData($event, fieldKey) {
      const modelDatas = this.$_getWsCRUD(fieldKey).modelDatas;
      for (let modelData of modelDatas) {
        if (modelData.id === $event.id) {
          modelData.dot = H_idtf.setDot(modelData, this.subModelName);
          for (let key in this._fields[fieldKey].fields) {
            if (!this._fields[fieldKey].updateHideFields.includes(key)) {
              const field = this._fields[fieldKey].fields[key];
              try {
                await S_idtf.updateCRUDData($event, field, modelData, key, this.subModelName);
              } catch (error) {
                alert(error);
              }
            }
          }
        }
      }
    },
    async $_onSubmit(submitUrl) {
      this.isLoading.submit = true;
      this.$refs.WsAlertDialog.startLoading();
      try {
        await this.$axios.post(submitUrl);
        this.$refs.WsAlertDialog.stopLoading();
        this.isLoading.submit = false;
        this.$_onClosePopup('WsAlertDialog');
        this.resultDialog.isReviewSuccess = true;
        this.resultDialog.title = '覆核法規內容格式更新作業完成';
        this.$_onOpenPopup('resultDialog');
      } catch (error) {
        this.$refs.WsAlertDialog.stopLoading();
        this.isLoading.submit = false;
        this.$_onClosePopup('WsAlertDialog');
        this.resultDialog.isReviewSuccess = true;
        this.resultDialog.title = '覆核法規內容格式更新作業完成';
        this.$_onOpenPopup('resultDialog');
      }
    },
    async $_onInRowBtnClick(fieldKey, item, btn, modelDatas) {
      const tarIndex = modelDatas.findIndex((e) => e.id == item.id);
      const tarModelData = modelDatas[tarIndex];
      if (btn.value !== undefined) {
        item.btnLoading = true;
        btn.action(item);
        const isCheckedValueSame = modelDatas[tarIndex][this.subModelName] == btn.value;
        const formattedData = this.$_setValueInUpdateData(
          fieldKey,
          { ...item, value: btn.value },
          isCheckedValueSame,
        );
        modelDatas[tarIndex][this.subModelName] = formattedData[this.subModelName];
        await this.$axios.post(this.subModelSubmitUrl, {
          act_idtf_assignment_items: [formattedData],
        });
        item.dot = H_idtf.setDot(formattedData, this.subModelName);
        item.btnLoading = false;
        if (btn.value === 0 && !isCheckedValueSame) {
          this.$_getCheckFailDialog(fieldKey).open(tarModelData);
        }
      } else if (btn.type === 'update' || btn.type === 'read') {
        const field = this._fields[fieldKey];
        const dialogData = field.setDialogShowData
          ? field.setDialogShowData(tarModelData)
          : tarModelData;
        this.$refs[`${btn.type}Dialog_${fieldKey}`][0].open(dialogData);
      } else if (btn.type === 'delete') {
        this.$_onOpenPopup('deleteDialog', { ...tarModelData, fieldKey });
      }
    },
    $_setValueInUpdateData(fieldKey, $event, isCheckedValueSame) {
      const versionId = H_idtf.getVersionId(
        $event,
        this.modelData,
        this._fields[fieldKey].getVersionId,
      );
      const versionKey = H_idtf.getVersionKey(
        this._fields[fieldKey].tab,
        this._fields[fieldKey].modelName,
      );
      let data = {
        [`${versionKey}`]: versionId ? versionId : $event.id,
        [this.subModelName]: isCheckedValueSame ? null : $event.value,
      };
      const id = this._fields[fieldKey].getIdtfAssigmentItemId(
        $event,
        this.modelData[0],
        versionKey,
        versionId,
      );
      data = id ? { ...data, id } : data;
      const index = H_idtf.getUpdateDataIndex(
        this.updateData[`${this.subModelName}`],
        versionKey,
        versionId,
      );
      if (!isCheckedValueSame) {
        H_idtf.updateUpdateData(this.updateData, data, this.subModelName, index);
      } else {
        this.updateData[`${this.subModelName}`].splice(index, 1);
      }
      return data;
    },
    $_getBreadcrumbsItems() {
      if (!this.modelData || !this.breadcrumbs) return;
      const _breadcrumbsItems = H_idtf.getBreadcrumbsItems(this.modelData, this.breadcrumbs.fields);
      return _breadcrumbsItems;
    },
    async $_onSaveRemark(fieldKey, $event) {
      this.isLoading.checkFailDialog = true;
      const versionId = H_idtf.getVersionId(
        $event,
        this.modelData,
        this._fields[fieldKey].getVersionId,
      );
      const versionKey = H_idtf.getVersionKey(
        this._fields[fieldKey].tab,
        this._fields[fieldKey].modelName,
      );
      const index = H_idtf.getUpdateDataIndex(
        this.updateData[`${this.subModelName}`],
        versionKey,
        versionId,
      );
      for (let key in $event) {
        if (key !== 'id') {
          this.updateData[this.subModelName][index] = {
            ...this.updateData[this.subModelName][index],
            [`${key}`]: $event[key],
          };
        }
      }
      const formattedData = this.updateData[this.subModelName][index];
      try {
        await this.$axios.post(this.subModelSubmitUrl, {
          act_idtf_assignment_items: [formattedData],
        });
      } catch (error) {
        alert(error);
      } finally {
        this.isLoading.checkFailDialog = false;
        this.$_getCheckFailDialog(fieldKey).close();
      }
    },
    $_onTabSwitch($event, fieldKey) {
      this._fields[fieldKey].tab.value = $event;
    },
    async $_onDialogCustomAction($event, fieldKey, type) {
      if (type === 'read') {
        this.$_getReadDialog(fieldKey).close();
        const isClickCheckButton = $event.value !== undefined ? true : false;
        if (isClickCheckButton) {
          this.$refs[`iconBtn_${fieldKey}_${$event.value}_${$event.item.id}`][0].$_onClick();
        } else {
          const item = $event.item;
          this.$_getUpdateDialog(fieldKey).open({});
          if (this._fields[fieldKey].fetchDialogData) {
            this.isLoading.updateDialog = true;
            try {
              await this._fields[fieldKey].fetchDialogData(item);
            } catch (error) {
              alert(error);
            }
            this.isLoading.updateDialog = false;
          }
          this.$_getUpdateDialog(fieldKey).open(item);
        }
      } else if (type === 'update') {
        this.$_getReadDialog(fieldKey).open($event);
        this.$_getUpdateDialog(fieldKey).close();
      }
    },
    $_onSetModelDatas(modelData, fieldKey) {
      const keys = [
        'short_name',
        'act_comment',
        'status',
        'll_comment',
        'reference_link',
        'attaches',
        'act_cnt_check_result',
        'act_cnt_review_result',
        'act_cnt_updated_admin',
        'act_cnt_updated_at',
        'act_cnt_final_reviewer',
        'act_cnt_final_reviewed_at',
        'idtf_check_result',
      ];
      H_idtf.setModelDatas(modelData, fieldKey, keys, this.updateData, this.subModelName);
    },
    $_getUpdateDialog(fieldKey) {
      return this.$refs[`updateDialog_${fieldKey}`][0];
    },
    $_getReadDialog(fieldKey) {
      return this.$refs[`readDialog_${fieldKey}`][0];
    },
    $_getWsCRUD(fieldKey) {
      return this.$refs[`WsCRUD_${fieldKey}`][0];
    },
    $_getCheckFailDialog(fieldKey) {
      return this.$refs[`checkFailDialog_${fieldKey}`][0];
    },
    $_onOpenPopup(type, item) {
      const actionList = {
        WsAlertDialog: () => {
          let isItemFail = false;
          this.updateData[this.subModelName].forEach((item) => {
            if (item[this.subModelName] == 0) isItemFail = true;
          });
          this.submit.description = isItemFail
            ? '有法規或法條不通過，送出之後，將退回上一關「內容格式更新作業」，並且此法規內容格式狀態將會是「更新中」。'
            : '送出之後，將會進行「法規鑑別作業」，並且此法規內容格式狀態將會是「完成」、鑑別狀態將會是「鑑別中」。';
          this.$refs.WsAlertDialog.open();
        },
        resultDialog: () => this.$refs.resultDialog.open(),
        deleteDialog: (item) => this.$refs.deleteDialog.open(item),
      };
      if (actionList[type]) actionList[type](item);
    },
    $_onClosePopup(type) {
      const actionList = {
        WsAlertDialog: () => this.$refs.WsAlertDialog.close(),
        resultDialog: () => {
          this.resultDialog.isReviewSuccess = false;
          this.$refs.resultDialog.close();
        },
      };
      if (actionList[type]) actionList[type]();
    },
    async $_onBatchPass(fieldKey, modelDatas, selectedItems, btnList) {
      this.isLoading.batchPass = true;
      const btn = btnList.find((btn) => btn.value === 1);
      const selectedItemIdList = selectedItems.map((item) => item.id);
      const RowItemList = this.$refs[`WsCRUD_${fieldKey}`][0].$refs.WsDataTable._items;
      const task = [];
      modelDatas.forEach((modelData, modelDataIndex) => {
        if (
          selectedItemIdList.includes(modelData.id) &&
          !modelDatas[modelDataIndex][this.subModelName]
        ) {
          const tarRowItem = RowItemList.find(
            (item) => selectedItemIdList.includes(item.id) && item.id === modelData.id,
          );
          btn.action(tarRowItem);
          const formattedData = this.$_setValueInUpdateData(
            fieldKey,
            { ...tarRowItem, value: btn.value },
            false,
          );
          modelDatas[modelDataIndex][this.subModelName] = btn.value;
          task.push(
            this.$axios.post(this.subModelSubmitUrl, {
              act_idtf_assignment_items: [formattedData],
            }),
          );
          tarRowItem.btnLoading = true;
          tarRowItem.dot = { color: 'green' };
        }
      });
      await Promise.all(task);
      RowItemList.forEach((item) => (item.btnLoading = false));
      this.isLoading.batchPass = false;
    },
    $_initUpdateData(idtfItems) {
      const validItems = idtfItems.filter(
        (item) => item[this.subModelName] == '1' || item[this.subModelName] == '0',
      );
      const versionKeys = H_idtf.setVersionKeys(this.subModelName);
      const updateItemArr = validItems.map((item) => {
        const updateItem = {
          id: item.id,
          [this.subModelName]: item[this.subModelName],
        };
        const versionData = versionKeys.reduce((acc, key) => {
          if (item[key] && item[key].id) {
            acc[key] = item[key].id;
          }
          return acc;
        }, {});
        return { ...updateItem, ...versionData };
      });
      this.updateData[this.subModelName].push(...updateItemArr);
    },
    $_onConfirmResultDialog() {
      if (this.resultDialog.isReviewSuccess) this.$router.push(this.breadcrumbs.fields[0].url);
      this.$_onClosePopup('resultDialog');
    },
    async $_onDeleteSubmit(item) {
      const { act_idtf_assignment_item, id: articleVersionId, fieldKey, article } = item;
      const deleteDialog = this.$refs.deleteDialog;
      deleteDialog.startLoading();
      await S_idtfItem.delete(act_idtf_assignment_item?.id);
      await S_articleVersion.delete(articleVersionId);
      await S_article.delete(article?.id);
      const wsCRUD = this.$refs[`WsCRUD_${fieldKey}`][0];
      if (wsCRUD) wsCRUD.$_removeModeldataById(articleVersionId);
      this.idtfItemsNumber -= 1;
      deleteDialog.stopLoading();
      deleteDialog.close();
    },
  },
  computed: {
    _idtfId() {
      return this.$route.params.id;
    },
    _fields() {
      let fields = H_idtf.setFields(
        this.modelData,
        this.subModelName,
        false,
        this._isStageFinished,
      );
      for (let key in fields) {
        fields[key] = {
          ...fields[key],
          ...this.fields[key],
        };
      }
      return fields;
    },
    _fetchSetting() {
      return H_idtf.setFetchSetting(this.$route.params.id);
    },
    _customBtns() {
      return {
        title: '完成編輯',
        submitUrl: `act_idtf_assignment/${this.$route.params.id}/act_cnt_reivew/complete`,
      };
    },
    _remainingItems() {
      return this.idtfItemsNumber - this._checkedNum;
    },
    _isCheckedAll() {
      return this._remainingItems === 0;
    },
    _checkedNum() {
      return this.updateData[this.subModelName].length;
    },
    _isStageFinished() {
      return H_idtf.isStageFinished(this.modelData[1], this.subModelName);
    },
  },
};
</script>
